import { Cart } from 'types'
import { DetectSiteDomain } from '@utils/detect-site-domain'
import { CheckoutEventDTO, CheckoutEventTypes } from '../../../../types/analytics/analytics-data'
import { siteNameStore, splitProductDescription } from '@utils/analytics/common'
import { getCurrentSynsisalRoute } from '@utils/get-synsisal-route'

export const createBeginCheckoutDTO = (
  data: Cart,
  siteDomainInfo: DetectSiteDomain,
  promoCode?: string,
  previousRoute?: string,
): CheckoutEventDTO | undefined => {
  const { furnitureSite, synsisalSite } = siteDomainInfo

  if (furnitureSite) {
    return {
      event: CheckoutEventTypes.BEGIN_CHECKOUT,
    }
  }

  if (!data) {
    return
  }

  return {
    event: CheckoutEventTypes.BEGIN_CHECKOUT,
    ecommerce: {
      currency: 'USD',
      value: !synsisalSite ? parseFloat(data.total.replace('$', '').replace(',', '')) : 0,
      ...(promoCode && { coupon: promoCode || '' }), // Add coupon code if exists
      items: data.items.map((item) => {
        const [name, color] = splitProductDescription(item.description)
        return {
          item_name: synsisalSite ? item.description : item.description.split(':').length > 1 ? name : item.description,
          item_id: item.metadata?.contentful_id,
          affiliation: siteNameStore,
          ...(promoCode && { coupon: promoCode || '' }), // Add coupon code if exists
          currency: 'USD',
          price: !synsisalSite ? parseFloat(item.netPrice.replace('$', '').replace(',', '')) : 0,
          ...(synsisalSite && { item_brand: 'synsisal' }), // Add brand if is synsisal (only for synsisal site
          item_category: !synsisalSite ? item.metadata?.category || '' : `${name} samples`,
          ...(!synsisalSite && {
            item_category2: item.metadata?.category2 || '', // Choose rug type or carpet
            item_category3: item.metadata?.category3 || '', // choose border material
            item_category4: item.metadata?.category4 || '', // type of rug pad user choose
            item_category5: item.metadata?.category5 || '', // choose weave color
          }),
          item_variant: !synsisalSite ? item.metadata?.category5 || '' : color, // color of the product
          item_stock_detail: 'In_stock',
          item_list_name: !synsisalSite
            ? item.metadata?.itemListName || ''
            : previousRoute ?? getCurrentSynsisalRoute(),
          ...(item.metadata?.index && { index: item.metadata?.index }),
          quantity: item.quantity,
        }
      }),
    },
  }
}
